<template>
  <!-- <router-link :to="link"> -->
  <div class="app-image" v-bind:class="{portrait: portrait}">
    <img v-show="!loading" :src="src"/>
    <div class="image-overlay" v-if="metadata">
      <div v-if="metadata.title && !metadata.source">{{metadata.title}}</div>
      <div v-if="metadata.title && metadata.source"><a :href="metadata.source" target="_blank">{{metadata.title}}</a></div>
    </div>
    
    
    <!-- <div class="app-image" v-bind:style="{ 'background-image': 'url(' + image.url + ')' }"> -->
  </div>
  <!-- </router-link> -->
</template>

<script>
export default {
  props: ['src', 'metadata', 'grid_item'],
  data: () => {
    return {
      portrait: false,
      loading: true,
      img: null,
    }
  },
  computed: {
    computed_width: function() {
      return this.default_width
    },
  },
  created() {
    this.get_image_dimensions()
  },
  watch: {
    'src' (){
      this.get_image_dimensions()
    },
  },
  methods: {
    get_image_dimensions: function() {
      this.img = new Image()
      this.img.onload = () => {
        if(this.img.height > this.img.width && !this.grid_item) {
          this.portrait = true
        }
        this.loading = false
      }
      this.img.src = this.src
    }
  }
}
</script>
